/**
 * @file コンポーネント：検索結果ページ検索条件フィルター スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul`
    display: flex;
    flex: wrap;
`;

export const StyledListItem = styled.li`
    margin: 0 8px 8px 0;
`;

export const StyledListFilter = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 8px 4px;
    background-color: #d9d9d9;
    color: #000000;
    font-size: 14px;
    line-height: 16px;

    &::before {
        width: 16px;
        margin-right: 8px;
        font-weight: bold;
        text-align: center;
        content: "\f055";
    }

    &:hover {
        &::before {
            content: "\f056";
        }
    }
`;

export const StyledListFilterLabel = styled.span`
    text-transform: uppercase;
    white-space: nowrap;

    &::after {
        margin: 0 2px;
        content: ":";
    }
`;

export const StyledListFilterValue = styled.span`
    &[data-type="tag"] {
        height: 20px;
        padding: 0 8px;
        border: 1px solid #696d71;
        border-radius: 10px;
        background-color: #343a40;
        color: #e5e6e6;
        font-size: 10px;
        line-height: 18px;
    }

    > i {
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        vertical-align: top;
    }
`;
